import axios from '@/plugins/axios'

const getHeaders = () => {
  const userStr = localStorage.getItem('user')
  if (!userStr) return {}
  const { key } = JSON.parse(userStr)
  return { headers: { Authorization: `Token ${key}` } }
}

const PedidosTiendaStore = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async fetchPedidos({}, { page = 1, q = '', ordering = '' } = {}) {
      const params = { page }
      if (q) params.q = q
      if (ordering) params.ordering = ordering
      const response = await axios.get('/api/store/pedidos/center/', {
        params,
        ...getHeaders(),
      })
      return response.data
    },

    async fetchPedidoDetail({}, id) {
      const response = await axios.get(
        `/api/store/pedidos/center/${id}/`,
        getHeaders()
      )
      return response.data
    },

    async downloadDocumento({}, { id, tipoDocumento }) {
      const response = await axios.get(
        `/api/store/pedido/${id}/documento/pdf/`,
        { ...getHeaders(), responseType: 'blob' }
      )
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: 'application/pdf' })
      )
      const link = document.createElement('a')
      link.href = url
      link.setAttribute(
        'download',
        `${tipoDocumento || 'documento'}-pedido-${id}.pdf`
      )
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    },
  },
}

export default PedidosTiendaStore
